var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"read-book"},[_c('text-viewer',{attrs:{"pagetext":_vm.pageContent,"isbn":_vm.selectedBookId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }